









































import Vue from 'vue';
import { FormFieldValidation, RouteHelpers, ObjectHelper } from '@/mixins';
import {
  ArenaSignSignerRoleModel,
  ArenaSignSignerRoleConfigurationModel,
  ArenaSignSignerRoleCreateUpdateModel,
  Configuration
} from '@/types';
import { DocuSignConfigurationService } from '@/services/docuSign/DocuSignConfigurationService';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import ArenaSignUpdateSignerRole from '@/components/configuration/arenaSign/ArenaSignUpdateSignerRole.vue';

export default Vue.extend({
  name: 'DocusignAddSignerRole',
  mixins: [FormFieldValidation, RouteHelpers, ObjectHelper],
  data() {
    return {
      isLoading: false,
      signerRoleConfiguration: {} as ArenaSignSignerRoleConfigurationModel,
      signerRole: {} as ArenaSignSignerRoleCreateUpdateModel,
      submitIsLoading: false,
      serverValidationMessage: '',
      hasError: false,
      errorMessage: '',
      authenticationTypes: [{ description: 'Standard', key: 0 }]
    };
  },
  methods: {
    async onSubmit(this: any, signerRole: ArenaSignSignerRoleCreateUpdateModel) {
      try {
        this.submitIsLoading = true;
        this.serverValidationMessage = '';
        const result = await DocuSignConfigurationService.createSignerRoleAsync(this.documentTypeId, this.signerRole);

        if (result.hasNotification && !result.showToast) {
          this.serverValidationMessage = result.notification;
          this.addFormValidationError(result.notification);
          this.submitIsLoading = false;
          return;
        }

        SnotifyConfiguration.showSuccess('Signer created successfully.');
        this.setApplicationDirty(false);
        this.navigateToSignerRolebManagement();
      } catch {
        this.serverValidationMessage = 'Error creating signer role';
      } finally {
        this.submitIsLoading = false;
      }
    },
    async getDataAsync(this: any, id: number) {
      this.isLoading = true;
      this.serverValidationMessage = '';
      try {
        this.signerRoleConfiguration = await DocuSignConfigurationService.getSignerRoleConfigurationAsync({
          documentTypeId: this.documentTypeId,
          signerRoleId: null
        });
      } catch (error) {
        this.serverValidationMessage = error;
      } finally {
        this.isLoading = false;
      }
    },
    navigateToSignerRolebManagement(this: any, id: number) {
      this.$router.push({ name: Configuration.DocuSign.SignerRole.Management.name, params: { id } });
    }
  },
  computed: {
    documentTypeId(): number {
      return Number(this.$route.params.documentTypeId);
    },
    pageTitle(): string {
      return 'Add Signer Role';
    }
  },
  mounted(this: any) {
    this.getDataAsync();
  },
  components: {
    MStoreFormSelect,
    LoadingSpinner,
    ArenaSignUpdateSignerRole
  }
});
